import { action } from 'satcheljs/lib/legacy';
// This is to workaround a behavior in Edge/IE
// See VSO 15323 for more details
export default action('setIsFocusWorkaroundDivShown')(function setIsFocusWorkaroundDivShown(viewState, isShown) {
    viewState.isFocusWorkaroundDivShown = isShown;
});
//# sourceMappingURL=setIsFocusWorkaroundDivShown.js.map